import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsBodyText as BodyText } from './src/BodyText.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(BodyText);
export const FsBodyText = customElementClass;
export const tagName = safeTagName;
//# sourceMappingURL=fs-body-text.js.map